import {Link} from 'react-router-dom'
import PropTypes from 'prop-types';

function Header({content}){
    return (
        <header className="masthead">
                <div className="container">
                    {content.subheading ?
                        <div className="masthead-subheading">
                            {content.subheading}
                        </div>
                        : null
                    }
                    <div className="masthead-heading text-uppercase">
                        {content.heading}
                    </div>
                    {content.linkBtn ? 
                        <Link className="btn btn-primary btn-xl text-uppercase" to={process.env.PUBLIC_URL + "/products"} style={{ textDecoration: 'none' }}>
                            캐리어 보러가기
                        </Link>
                        : null
                    }
                    {content.reviewBtn ? 
                        <Link className="btn btn-primary btn-xl text-uppercase edit" to={process.env.PUBLIC_URL + "/review"} style={{ textDecoration: 'none' }}>
                            여행후기 보러가기
                        </Link>
                        : null
                    }
                </div>
        </header>
    );
}

Header.propTypes = {
    content: PropTypes.object.isRequired
}

export default Header;